import { PaymentPercentages } from '@/hooks/useOrderStats';
import { CircularProgress, Stack } from '@mui/material';
import { ResponsiveContainer, PieChart, Pie, Legend, Cell } from 'recharts';
import { blue, green, purple } from "@mui/material/colors";
import { useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';

interface Props {
    isLoading: boolean;
    data: PaymentPercentages;
}

const COLORS = [blue[500], green[500], purple[400]];

const PaymentTypeChart = ({ isLoading, data }: Props) => {
    const payments = useMemo(() => {
        if (isEmpty(data)) {
            return []
        }
        return Object.values(data).map((p) => ({
            percent: Number(p.value.toFixed(0)),
            value: p.label
        }))
    }, [data])

    if (isLoading) {
        return (
            <Stack flex={1} padding={4} alignItems="center" justifyContent="center">
                <CircularProgress />
            </Stack>
        )
    }

    return (
        <ResponsiveContainer width="100%" height={250}>
            <PieChart
                height={400}
                width={400}
                style={{ fontFamily: "'Fira Sans', sans-serif" }}
            >
                <Pie
                    cx="50%"
                    cy="50%"
                    data={payments}
                    dataKey="percent"
                    fill="#8884d8"
                    innerRadius={40}
                    nameKey="value"
                    outerRadius={60}
                >
                    {payments.map((_, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Legend iconType="circle" />
            </PieChart>
        </ResponsiveContainer>
    )
}

export default PaymentTypeChart;
